export enum BonusSettlementTab {
    Supplier = 'supplier',
    Customer = 'customer',
}
